import ev from "../util/enumValue";

enum AnimationStage {
    IN = ev('IN', 1),
    OUT = ev('OUT', 2),
    LOOP = ev('LOOP', 3)
}

export default AnimationStage;
